<template>
  <transition name="fade">
    <div :class="styleClass" :style="styles" ref="wrap">
      <slot></slot>
    </div>
  </transition>
</template>
<script>
import Popper from 'popper.js'
import {findComponentUpward, getStyle} from '../../utils/assist'

// 此组件从原来的dropdown组件中的drop子组件改变而来,
// 只能作为其他组件的子组件使用
export default {
  name: 'TPopBox',
  props: {
    placement: {
      type: String,
      default: 'bottom-start'
    },
    styleClass: {
      type: String,
      default: 'dropdown__menu'
    }
  },
  data () {
    return {
      popper: null,
      width: ''
    }
  },
  computed: {
    styles () {
      let style = {}
      if (this.width) style.minWidth = `${this.width}px`
      return style
    }
  },
  created () {
    this.$on('on-update-popper', this.update)
    this.$on('on-destroy-popper', this.destroy)
  },
  beforeDestroy () {
    if (this.popper) {
      this.destroy()
    }
  },
  methods: {
    update () {
      if (this.popper) {
        this.$nextTick(() => {
          this.popper.update()
        })
      } else {
        let vm = this
        const isIE10 = navigator.appVersion.indexOf('MSIE 10') !== -1
        const boundariesElement = isIE10 === true ? 'window' : 'viewport'
        vm.$nextTick(() => {
          if (!vm.hasParent()) { // 嵌套的dropdown不再插入dropdown
            document.body.appendChild(vm.$el)
            vm.$el.style.minWidth = vm.$parent.$refs.reference.offsetWidth + 'px'
          }
          vm.popper = new Popper(vm.$parent.$refs.reference, vm.$el, {
            placement: vm.placement,
            onCreate (data) {
              vm._resetPositionfromOrigin(data)
            },
            modifiers: {
              preventOverflow: {
                boundariesElement: boundariesElement,
                escapeWithReference: true // 滚动的时候下拉是跟着Reference走还是根据滚动的顶端
              },
              computeStyle: {
                gpuAcceleration: false
              }
            }
          })
        })
      }
      // set a height for parent is Modal and Select's width is 100%
      if (this.$parent.$options.name === 'TSelect') {
        this.width = parseInt(getStyle(this.$parent.$el, 'width'))
      }
    },
    hasParent () {
      const $parent = findComponentUpward(this, 'TPopBox')
      return !!$parent
    },
    destroy () {
      const vm = this
      if (vm.popper) {
        setTimeout(() => {
          vm.popper.destroy()
          vm.popper = null
          if (!vm.hasParent()) {
            vm.$el.parentNode.removeChild(vm.$el)
          }
        }, 300)
      }
    },
    _resetPositionfromOrigin (data) {
      if (!data.instance) {
        return
      }
      // 针对位置计算误差
      const refRight = data.instance.reference.getBoundingClientRect().right
      const popperLeft = data.instance.popper.getBoundingClientRect().right
      if (refRight - popperLeft > 1) { // 超过1px偏差
        this.popper && this.popper.scheduleUpdate()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// pop-box.vue?78f8acde